import { useResizeObserver } from "@wojtekmaj/react-hooks";
import React, { useCallback, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import Footer from "../components/Footer.jsx";
import Navbar from "../components/Navbar.jsx";
import { PageLoader } from "../components/PageLoader.jsx";
import { useNavigate } from "react-router-dom";
import { LuMoveLeft } from "react-icons/lu";

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const resizeObserverOptions = {};
const maxWidth = "1024";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [containerRef, setContainerRef] = useState(null);
  const [containerWidth, setContainerWidth] = useState();

  const onResize = useCallback((entries) => {
    const [entry] = entries;

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  useResizeObserver(containerRef, resizeObserverOptions, onResize);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  return (
    <div className=" bg-[color:var(--bg-primary)] font-[Montserrat] text-white">
      <div className="relative">
        <Navbar page="privacy-policy" />
        <div className="fixed top-16 z-50 ms-[8vw] mt-3  w-full bg-transparent">
          <div onClick={() => navigate(-1)} className="cursor-pointer">
            <LuMoveLeft className="text-xl text-black sm:text-2xl " />
          </div>
        </div>
        <div
          className="Example__container__document pt-10"
          ref={setContainerRef}
        >
          <Document
            file="/docs/privacy-policy.pdf"
            onLoadSuccess={onDocumentLoadSuccess}
            options={options}
            className="flex w-full flex-col justify-center"
            loading={
              <div className="!h-[200vh] bg-white">
                <PageLoader />
              </div>
            }
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                className="flex w-full justify-center"
                width={
                  containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth
                }
              />
            ))}
          </Document>
        </div>
        <Footer page="privacy-policy" />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
